module.exports = __webpack_public_path__ + "media/images/emblems/Grens-coat_of_arms-a443f6ce4a9ffcb62036fc51673a5a65.svg";